import { DialogContent, styled } from "@mui/material";

export const StyledAddProfessional = {
  RowContainer: styled("div")({
    display: "flex",
    flex: 1,
    alignItems: "center",
    marginBottom: 10,
  }),
  LoadingContainer: styled(DialogContent)({
    marginTop: 40,
    marginBottom: 80,
  }),
  input: {
    marginRight: 2,
  },
};

export const ProfessionalControlWrapper = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
});
